import StaticBuilderModalEnum from 'StaticBuilderModals/StaticBuilderModalConstants';

export const DEFAULT_STATE = {
  isSecondActionModalOpen: false,
};

const StaticBuilderModalHandler = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case StaticBuilderModalEnum.OPEN_STATIC_SECOND_ACTION_MODAL:
      return {
        ...state,
        isSecondActionModalOpen: true,
      };
    case StaticBuilderModalEnum.CLOSE_STATIC_SECOND_ACTION_MODAL:
      return {
        ...state,
        isSecondActionModalOpen: false,
      };
    default:
      return state;
  }
};

export default StaticBuilderModalHandler;



// WEBPACK FOOTER //
// ./src-react/StaticBuilderModals/StaticBuilderModalReducer.jsx